import {
  Box,
  useTheme,
  IconButton,
  TextField,
  styled,
  FormHelperText,
  Tooltip,
  } from "@mui/material";
import Typography from "@mui/material/Typography";
import { tokens } from "../../theme";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import React from "react";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";

import { initializeEncryption } from "../../services/AesGcmEncryption";
import { Stack } from "@mui/material";
import { InputLabel, Select, MenuItem } from "@mui/material";
import { Search } from "@mui/icons-material";
import { InputAdornment } from "@mui/material";

import CustomButton from "../../components/CustomButton";
import { useEffect, useState } from "react";
import {
  showErrorAlertDialog,
  triggerFileDownload,
} from "../../config/AppConfig";
import { useAtom } from "jotai";
import DebugLog from "../../utils/DebugLog";
import { FormControl } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  downloadReportModuleFile,
  getDateDropdownListApiData,
  getPayoutCycleDatesDropdownListData,
  } from "../../services/ApiService";
import { saveAs } from "file-saver";

import {
  getFromLocalStorage,
  getFromLocalStorageJsonObject,
  saveToLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import {
  AWAITING_FILE_DOWNLOAD,
  COMPANY_CODE,
  COMPANY_ID,
  COMPANY_NAME,
  IS_EXTERNAL_USER,
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import {
  ALERT,
  ERROR,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  PROCESSING_PLEASE_WAIT,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../constants/Strings";
import { generateRequestId } from "../../utils/RequestIdGenerator";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import ConnectionStatus from "../../utils/ConnectionStatus";
import * as CONSTANT from "../../constants/Constant";
import useAxiosHook from "../../hooks/UseAxios";
import useAxiosHookForDownloadReportInitiate from "../../hooks/UseAxiosForReportDownloadInititate";

dayjs.extend(customParseFormat);

const FilterReports = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const [redirectToLoginOnDialogClose, setRedirectToLoginOnDialogClose] =
    useState(false);

  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [checked, setChecked] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState("option1");
  const dropdownHeight = "400px"; // Set the desired height

  const [selectedDate, setSelectedDate] = useState("");
  const [selectedFromDate, setSelectedFromDate] = useState("");
  const [selectedToDate, setSelectedToDate] = useState("");
  // Retrieve location state
  const location = useLocation();
  const dataProps = location.state && location.state.data;
  const flowProp = location.state && location.state.type;
  const selectedCompanyDetails = location.state && location.state.dealerDetails;
  const [companyCode, setCompanyCode] = useState("");
  const [branchCode, setBranchCode] = useState("");
  const [loading, setLoading] = useState(false);

  const [getProgressbarText, setProgressbarText] = useState("");

  // dropdown state

  const [reportTypeOptions, setReportTypeOptions] = useState([]);
  const [reportType, setReportType] = useState([]);

  const [payoutCycleDates, setPayoutCycleDatesDropdownOptions] = useState([]);
  const [payoutCycleValue, setPayoutCycleDatesValue] = useState([]);

  const [dropdownOpitons, setDropdownOptions] = useState([]);
  const [dropdownValue, setDropdownValue] = useState([]);

  const [monthDropdownValue, setMonthDropdwonValue] = useState([]);
  const [yearDropdownValue, setYearDropdownValue] = useState([]);
  const [transactionTypeDropdownValue, setTransactionTypeDropdownValue] =
    useState([]);

  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedDayCycle, setSelectedDayCycle] = useState("");

  const [selectedTrnsactionType, setSelectedTransactionType] = useState("");

  const [selectedDropdownBatchNo, setSelectedDropdownBatchNo] = useState([]);

  const [reportTypeSelection, setReportTypeSelection] = useState("");
  const [datePickerMinDay, setDatePickerMinDay] = useState(0);
  const [textfieldRequired, setTextfieldRequired] = useState(false);
  const [toAndFromDateRequired, setToAndFromDateRequired] = useState(false);
  const [
    toAndFromDateSubmitButtonRequired,
    setToAndFromDateSubmitButtonRequired,
  ] = useState(false);

  const [dateDropdownRequired, setDateDropdownRequired] = useState(false);
  const [dateFilterRequired, setDateFilterRequired] = useState(false);
  const [monthFilterRequired, setMonthFilterRequired] = useState(false);
  const [yearFilterRequired, setYearFilterRequired] = useState(false);
  const [dayCycleFilterRequired, setDayCycleFilterRequired] = useState(false);
  const [groupNameRequired, setGroupNameRequired] = useState(false);
  const [groupNameDropdownValue, setGroupNameDropdownValue] = useState([]);

  const [transactionTypeRequired, setTransactionTypeRequired] = useState(false);

  const [subReportTypeOptions, setSubReportTypeOptions] = useState([]);
  const [subReportType, setSubReportType] = useState([]);
  const [reportGroup, setReportGroup] = useState([]);
  const [displayFilterLabel, setDisplayFilterLabel] = useState(false);
  const [displayName, setDisplayName] = useState(false);
  const [groupingKeyDisplayName, setGroupingKeyDisplayName] = useState("");
  const [isGroupingKey, setGroupingKey] = useState(false);

  const [filterKey, setFilterKey] = useState("");
  const [fileType, setFileType] = useState("");
  const [isBranchCodeRequired, setIsBranchCodeRequired] = useState(true);
  const [isCompanyCodeRequired, setIsCompanyCodeRequired] = useState(true);

  const [isExternalUser, setIsExternaluser] = useState(false);

  const [filterValues, setFilterValues] = useState([]);
  const [filterValuesOptions, setFilterOptions] = useState("");

  const [branchTypeOpitons, setBranchTypeOptions] = useState([]);
  const [branchValue, setBranchValue] = useState([]);

  const { data, error, showProgressBar, fetchData } = useAxiosHook();
  const [errors, setErrors] = useState({});

  const [reportFormat, setReportFormat] = useState("");
  const [reportExtension, setReportExtension] = useState("");
  const [reportTemplate, setReportTemplate] = useState("");

  const {
    downloadedDataFromInitiateApi,
    downloadInitiateApiError,
    showProgressBarForDownloadInitiate,
    fetchDataFromDownloadInitiate,
  } = useAxiosHookForDownloadReportInitiate();

  const [triggerDownload, setInititateFileDownloadTrigger] =
    useAtom(triggerFileDownload);

  // "reportFormat": "XLX_TABS",
  //                       "reportExtension": "xlsx",
  //                       "reportTemplate": "PREPAID_COMMISSION_STATEMENT"

  // const classes = useStyles();
  const [formData, setFormData] = useState({
    reportType: "",
    subType: "",
    companyName: "",
    branch: "",
    addFilter: "",
    text: "",
    selectedDateDropdown: "",
    reportGroup: "",
    month: "",
    year: "",
    dayCycle: "",
    transactionType: "",
    addMoreFilter: "",
    date: "",
  });

  useEffect(() => {
    getReportDetailInfo();

    if (getFromLocalStorage(IS_EXTERNAL_USER) === "Y") {
      setIsExternaluser(true);

      updateDataFromLoginPageIfItsExternalUser(
        getFromLocalStorage(COMPANY_CODE),
        getFromLocalStorage(COMPANY_NAME),
        getFromLocalStorage(COMPANY_ID),
      );
    }
  }, []);

  useEffect(() => {
    updateFromCompanyPageDataifAvailable();
  }, [reportType]);

  const updateDataFromLoginPageIfItsExternalUser = (
    companyCode,
    companyName,
    companyId,
  ) => {
    const value = {
      reportType: "",
      subType: "",
      companyName: companyName,
      branch: "",
      addFilter: "",
      text: "",
      selectedDateDropdown: "",
      reportGroup: "",
      month: "",
      year: "",
      dayCycle: "",
      transactionType: "",
      addMoreFilter: "",
      date: "",
    };
    DebugLog(JSON.stringify({ value }));
    setFormData(value);

    setCompanyCode(companyCode);
    callBranchDetailsApi(companyId, companyCode, companyName);
  };

  const updateFromCompanyPageDataifAvailable = () => {
    if (dataProps !== null) {
      const value = {
        reportType: dataProps.reportType !== null ? dataProps.reportType : "",
        subType: dataProps.subType !== null ? dataProps.subType : "",
        companyName:
          dataProps.companyName !== null ? dataProps.companyName : "",
        branch: dataProps.branch !== null ? dataProps.branch : "",
        addFilter: filterValuesOptions !== null ? filterValuesOptions : "",
        addMoreFilter:
          dataProps.addMoreFilter !== null ? dataProps.addMoreFilter : "",
        selectedDateDropdown:
          dataProps.selectedDateDropdown !== null
            ? dataProps.selectedDateDropdown
            : "",
        month: dataProps.selectedMonth !== null ? dataProps.selectedMonth : "",
        year:
          dataProps.selectedMonthYear !== null
            ? dataProps.selectedMonthYear
            : "",
        transactionType:
          dataProps.transactionType !== null ? dataProps.transactionType : "",
        date: dataProps.date !== null ? dataProps.date : "",
        reportGroup:
          dataProps.reportGroup !== null ? dataProps.reportGroup : "",
        dayCycle: dataProps.dayCycle !== null ? dataProps.dayCycle : "",
      };
      DebugLog(JSON.stringify({ value }));
      setFormData(value);
    }

    // get Branch Details Info
    if (
      selectedCompanyDetails !== null &&
      selectedCompanyDetails.companyId !== null
    ) {
      setCompanyCode(selectedCompanyDetails.companyCode);
      callBranchDetailsApi(
        selectedCompanyDetails.companyId,
        selectedCompanyDetails.companyCode,
        selectedCompanyDetails.companyName,
      );
    }
  };

  const getPayoutNamesList = (e) => {
    e.preventDefault();
    // Validation logic
    const newErrors = {};

    if (toAndFromDateRequired) {
      formData.from = selectedFromDate;
      formData.to = selectedToDate;
      if (!formData.from) {
        newErrors.from = "Please choose from Date";
      }
      if (!formData.to) {
        newErrors.to = "Please choose to Date";
      }
    }
    if (Object.keys(newErrors).length === 0) {
      // Form is valid, submit the data

      // const selectedFileType = fileType === "xlsx"? "XLS" :"PDF"
      getDateDropdownListData(reportTypeSelection, formData.from, formData.to);
    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };

  const getReportNamesList = (e) => {
    e.preventDefault();
    // Validation logic
    const newErrors = {};

    if (isGroupingKey === true && !formData.transactionType) {
      newErrors.transactionType = "Please choose Report Group";
    } else if (!formData.month) {
      newErrors.month = "Please choose Month";
    } else if (!formData.year) {
      newErrors.year = "Please choose Year";
    } else if (!formData.dayCycle) {
      newErrors.dayCycle = "Please choose Day Cycle";
    }

    // if (toAndFromDateRequired) {
    //   formData.from = selectedFromDate;
    //   formData.to = selectedToDate;
    //   if (!formData.from) {
    //     newErrors.from = "Please choose from Date";
    //   }
    //   if (!formData.to) {
    //     newErrors.to = "Please choose to Date";
    //   }
    // }
    if (Object.keys(newErrors).length === 0) {
      // Form is valid, submit the data

      // const selectedFileType = fileType === "xlsx"? "XLS" :"PDF"
      getDateDropdownList(
        formData.reportType,
        formData.year,
        formData.month,
        formData.dayCycle,
        formData.transactionType,
      );
      //getDateDropdownList("Payout Report", "2026", "APR","16","Device Reimbursement Bundle");
    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };
  useEffect(() => {
    if (showProgressBarForDownloadInitiate) {
      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBarForDownloadInitiate]);

  useEffect(() => {
    DebugLog("isBranchCodeRequired  >>>" + isBranchCodeRequired);
  }, [isBranchCodeRequired]);

  useEffect(() => {
    DebugLog("isCompanyCodeRequired  >>>" + isCompanyCodeRequired);
  }, [isCompanyCodeRequired]);

  useEffect(() => {
    if (error) {
      if (
        downloadInitiateApiError.message !== null &&
        downloadInitiateApiError.message !== undefined &&
        downloadInitiateApiError.message === ApiErrorCode.NETWORK_ERROR
      ) {
        showErrorAlert(ERROR, downloadInitiateApiError.message);
      } else if (
        downloadInitiateApiError.data.errorCode === ApiErrorCode.SESSION_EXPIRED
      ) {
        alert(downloadInitiateApiError.data.displayErrorMessage);
        navigate(CONSTANT.LOGIN);
      } else {
        const message =
          downloadInitiateApiError.data !== null
            ? downloadInitiateApiError.data.displayErrorMessage
            : downloadInitiateApiError.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
        );
      }
    }
  }, [downloadInitiateApiError]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validation logic
    const newErrors = {};

    if (!isExternalUser) {
      if (!formData.companyName.trim()) {
        newErrors.companyName = "Company Name is required";
      }
    } else {
      formData.companyName = getFromLocalStorage(COMPANY_NAME);
    }

    if (!formData.branch) {
      newErrors.branch = "Branch is required";
    }

    if (!formData.reportType.trim()) {
      newErrors.reportType = "Please select Report Type";
    }
    if (subReportTypeOptions.length > 0)
      if (!formData.subType.trim()) {
        newErrors.subType = "Please select Report Sub Type";
      }

    if (!formData.addFilter) {
      newErrors.addFilter = "Please choose a filter";
    }

    if (textfieldRequired) {
      if (!formData.text) {
        newErrors.text = "Text is required";
      }
    }
    if (toAndFromDateRequired) {
      formData.from = selectedFromDate;
      formData.to = selectedToDate;
      if (!formData.from) {
        newErrors.from = "Please choose from Date";
      }
      if (!formData.to) {
        newErrors.to = "Please choose to Date";
      }
    }
    if (dateDropdownRequired) {
      if (!formData.selectedDateDropdown) {
        newErrors.selectedDateDropdown = "Please choose Report Name";
      }
    }
    if (dateFilterRequired) {
      formData.date = selectedDate;
      if (!formData.date) {
        newErrors.date = "Please choose Date";
      }
    }

    if (monthFilterRequired) {
      if (!formData.month) {
        newErrors.month = "Please choose Month";
      }
    }
    if (yearFilterRequired) {
      if (!formData.year) {
        newErrors.year = "Please choose Year";
      }
    }

    if (dayCycleFilterRequired) {
      if (!formData.dayCycle) {
        newErrors.dayCycle = "Please choose Day Cycle";
      }
    }

    if (transactionTypeRequired) {
      if (filterKey === "transactionType") {
        if (!formData.transactionType) {
          newErrors.transactionType = "Please choose Transaction Type";
        }
      } else if (filterKey === "accountType") {
        if (!formData.transactionType) {
          newErrors.transactionType = "Please choose Account Type";
        }
      } else if (filterKey === "groupingKey") {
        if (!formData.transactionType) {
          newErrors.transactionType = "Please choose Report Group";
        }
      }
    }
    // Form is valid, submit the data
    if (Object.keys(newErrors).length === 0) {
      if (reportFormat === "XLS_TABS") {
        initiateRequestForReportDownload(
          selectedDropdownBatchNo,
          reportTemplate,
          reportFormat,
        );
      } else {
        const selectedFileType = fileType === "XLS" ? "XLS" : "PDF";
        downloadReportsDetails(formData, 0, selectedFileType);
      }
    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };

  useEffect(() => {
    DebugLog(JSON.stringify({ dataProps }));
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate]);

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  useEffect(() => {
    if (showProgressBar) {
      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBar]);

  // useEffect(() => {
  //   DebugLog("RESPONSE FROM API:"+JSON.stringify(data))
  // }, [data]);

  useEffect(() => {
    if (error) {
      const isSessionExpired =
        error.data?.errorCode === ApiErrorCode.SESSION_EXPIRED;
      setRedirectToLoginOnDialogClose(isSessionExpired);

      if (
        error.data != null &&
        error.data.responseCode != null &&
        error.data.responseCode != "-1"
      ) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
        );
      } else {
        const message =
          error.data != null ? error.data.displayErrorMessage : error.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
        );
      }
    }
  }, [error]);

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  function handleErrorDialogConfirm() {
    if (redirectToLoginOnDialogClose) {
      setRedirectToLoginOnDialogClose(false);
      navigate(CONSTANT.LOGIN);
    }
  }

  function getReportDetailInfo() {
    try {
      if (isNetworkConnectionAvailable) {
        const requestObject = {
          loginUserId: getFromLocalStorage(USER_ID),
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_REPORT_DETAILS_LIST,
        ).then((encryptedContentData) => {
          fetchData(
            process.env.REACT_APP_GET_REPORTS_DETAILS_API_URL,
            ApiType.GET_REPORT_DETAILS_LIST,
            ApiType.POST_METHOD,
            encryptedContentData,
            {},
            (data) => {
              if (data !== null) {
                setReportTypeOptions(
                  data.result.reports.map((item) => item.reportType),
                );
                setReportType(data.result.reports);
              }
            },
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
      );
    }
  }

  function callBranchDetailsApi(companyId, companyCode, companyName) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);
        let requestObject;
        if (companyId !== null && companyId !== undefined) {
          requestObject = {
            branchParentId: companyId,
          };
        } else if (companyCode !== null && companyCode !== undefined) {
          requestObject = {
            branchParentCode: companyCode,
          };
        } else if (companyName !== null && companyName !== undefined) {
          requestObject = {
            branchParentName: companyName,
          };
        }

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_BRANCH_DETAILS_LIST,
        ).then((encryptedContentData) => {
          fetchData(
            process.env.REACT_APP_GET_BRANCH_DETAILS_API_URL,
            ApiType.GET_BRANCH_DETAILS_LIST,
            ApiType.POST_METHOD,
            encryptedContentData,
            {},
            (data) => {
              if (data !== null) {
                if (data.result.companyAndBranchPage.content.length > 0) {
                  setBranchTypeOptions(
                    data.result.companyAndBranchPage.content.map(
                      (item) => item.branchName,
                    ),
                  );
                  setBranchValue(data.result.companyAndBranchPage.content);
                } else {
                  showErrorAlert(
                    "Alert",
                    "No Branch Found, Please choose other company!",
                  );
                }
              }
            },
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
      );
    }
  }

  const DATE_FORMAT = "DD-MM-YYYY";

  const parseReportDate = (date) => dayjs(date, DATE_FORMAT, true);

  const getDatePickerValue = (date) => {
    const dateObj = parseReportDate(date);
    return dateObj.isValid() ? dateObj : null;
  };

  const getAllowedDateRangeDays = () => {
    const days = Number(datePickerMinDay);
    return Number.isFinite(days) && days >= 0 ? days : 0;
  };

  const getDatePickerMin = (inputType) => {
    const todayObj = dayjs().startOf("day");
    const oldestAllowedDateObj = todayObj.subtract(
      getAllowedDateRangeDays(),
      "day",
    );

    if (inputType !== 1) {
      return oldestAllowedDateObj;
    }

    const selectedFromDateObj = selectedFromDate
      ? parseReportDate(selectedFromDate).startOf("day")
      : null;

    if (!selectedFromDateObj?.isValid()) {
      return oldestAllowedDateObj;
    }

    return selectedFromDateObj;
  };

  const getDatePickerMax = (inputType) => {
    const todayObj = dayjs().startOf("day");

    if (inputType !== 1) {
      return todayObj;
    }

    const selectedFromDateObj = selectedFromDate
      ? parseReportDate(selectedFromDate).startOf("day")
      : null;

    if (!selectedFromDateObj?.isValid()) {
      return todayObj;
    }

    const maxToDateObj = selectedFromDateObj.add(
      getAllowedDateRangeDays(),
      "day",
    );

    return todayObj.isBefore(maxToDateObj) ? todayObj : maxToDateObj;
  };

  const isRangeGreaterThanAllowed = (fromDateObj, toDateObj) => {
    const allowedDays = getAllowedDateRangeDays();
    return toDateObj.diff(fromDateObj, "day") > allowedDays;
  };

  const showRangeLimitError = () => {
    showErrorAlert(
      "Alert",
      "Please choose date range within " + getAllowedDateRangeDays() + " days",
    );
  };

  const resetDateByType = (inputType) => {
    if (inputType === 0) {
      setSelectedFromDate("");
    } else if (inputType === 1) {
      setSelectedToDate("");
    } else {
      setSelectedDate("");
    }
  };

  const handleDateSelect = (date, inputType) => {
    const todayObj = dayjs().startOf("day");
    const selectedDateObj = parseReportDate(date);

    if (!selectedDateObj.isValid()) {
      showErrorAlert("Alert", "Please choose a valid date");
      resetDateByType(inputType);
      return;
    }

    const selectedDayObj = selectedDateObj.startOf("day");

    if (selectedDayObj.isAfter(todayObj)) {
      showErrorAlert(
        "Alert",
        "Future dates selection is not allowed for Report Download",
      );

      resetDateByType(inputType);
      return;
    }

    if (inputType === 0) {
      const currentToDateObj = selectedToDate
        ? parseReportDate(selectedToDate).startOf("day")
        : null;
      const oldestAllowedFromDateObj = todayObj.subtract(
        getAllowedDateRangeDays(),
        "day",
      );

      if (selectedDayObj.isBefore(oldestAllowedFromDateObj)) {
        showRangeLimitError();
        setSelectedFromDate("");
        setSelectedToDate("");
        return;
      }

      setSelectedFromDate(date);

      if (
        currentToDateObj?.isValid() &&
        (selectedDayObj.isAfter(currentToDateObj) ||
          isRangeGreaterThanAllowed(selectedDayObj, currentToDateObj))
      ) {
        setSelectedToDate("");
      }

      DebugLog("Selected From Date " + date);
    } else if (inputType === 1) {
      const selectedFromDateObj = selectedFromDate
        ? parseReportDate(selectedFromDate).startOf("day")
        : null;

      if (!selectedFromDateObj?.isValid()) {
        showErrorAlert(
          "Alert",
          "Please choose From date before choosing To date",
        );
        setSelectedToDate("");
        return;
      }

      if (selectedDayObj.isBefore(selectedFromDateObj)) {
        showErrorAlert(
          "Alert",
          "To date should not be less than From date for Report Download",
        );
        setSelectedToDate("");
        return;
      }

      if (isRangeGreaterThanAllowed(selectedFromDateObj, selectedDayObj)) {
        showRangeLimitError();
        setSelectedToDate("");
        return;
      }

      setSelectedToDate(date);
      DebugLog("Selected To Date " + date);
    } else {
      setSelectedDate(date);
      DebugLog("Selected Date " + date);
    }
  };

  const handleDatePickerChange = (newValue, inputType, fieldName) => {
    if (!newValue) {
      resetDateByType(inputType);
      setErrors({ ...errors, [fieldName]: "" });
      return;
    }

    const selectedDateObj = dayjs(newValue);
    if (!selectedDateObj.isValid()) {
      showErrorAlert("Alert", "Please choose a valid date");
      resetDateByType(inputType);
      return;
    }

    handleDateSelect(selectedDateObj.format(DATE_FORMAT), inputType);
    setErrors({ ...errors, [fieldName]: "" });
  };

  const dropdownStyle = {
    maxHeight: dropdownHeight,
    overflowY: "auto", // Add a scrollbar if needed
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleDateDropdownSelection = (option, index) => {
    for (let i = 0; i < dropdownValue.length; i++) {
      const model = dropdownValue[i];
      if (model.payoutName === option && i === index) {
        setSelectedDropdownBatchNo(model.batchNo);
      }
    }
  };

  const handleMonthDropdownSelection = (option) => {
    setSelectedMonth(option);
  };

  const handleYearDropdownSelection = (option) => {
    setSelectedYear(option);
  };

  const handleDayCycleDropdownSelection = (option) => {
    setSelectedDayCycle(option);
  };

  const handleTransactionDropdownSelection = (option) => {
    setSelectedTransactionType(option);
  };

  const handleBranchSelection = (option) => {
    for (let i = 0; i < branchValue.length; i++) {
      const model = branchValue[i];
      if (model.branchName === option) {
        setBranchCode(model.branchCode);
      }
    }
  };
  const setUpFilterType = (filterData) => {
    if (
      filterData.filterType === "DROPDOWN" &&
      filterData.filterKey === "transactionType"
    ) {
      setGroupingKeyDisplayName(filterData.displayText);
      setFilterKey(filterData.filterKey);
      setTransactionTypeRequired(true);
      setTransactionTypeDropdownValue(filterData.filterValues);
      // setDatePickerMinDay(filterData.filterValues[0]);
    }
    if (
      filterData.filterType === "DROPDOWN" &&
      filterData.filterKey === "accountType"
    ) {
      setFilterKey(filterData.filterKey);
      setGroupingKeyDisplayName(filterData.displayText);
      setTransactionTypeRequired(true);
      setTransactionTypeDropdownValue(filterData.filterValues);
      // setDatePickerMinDay(filterData.filterValues[0]);
    }

    if (
      filterData.filterType === "DROPDOWN" &&
      filterData.filterKey === "groupingKey"
    ) {
      setFilterKey(filterData.filterKey);
      setGroupingKeyDisplayName(filterData.displayText);
      setTransactionTypeRequired(true);
      setGroupingKey(true);
      setTransactionTypeDropdownValue(filterData.filterValues);
      // setDatePickerMinDay(filterData.filterValues[0]);
    }
    // if (
    //   filterData.filterType === "DROPDOWN" &&
    //   filterData.filterKey === "getPayoutNameList"
    // ) {
    //   setDisplayName(filterData.displayText);
    //   setDateDropdownRequired(true);
    //   getDateDropdownList(reportTypeSelection,"","");

    //   setToAndFromDateSubmitButtonRequired(true)
    //   setToAndFromDateRequired(true);
    //   var minDay = Number(90);
    //   setDatePickerMinDay(minDay);
    // }

    if (
      filterData.filterType === "DROPDOWN" &&
      filterData.filterKey === "getPayoutNameList"
    ) {
      // setDisplayName(filterData.displayText);
      // setDateDropdownRequired(true);
      // getDateDropdownList(reportTypeSelection, "2026", "APR","16","Device Reimbursement Bundl");
      // setToAndFromDateSubmitButtonRequired(true);

      setDisplayName(filterData.displayText);
      setDateDropdownRequired(true);
      setGroupingKey(false);
      //getDateDropdownList(reportTypeSelection, "2026", "APR","16","Device Reimbursement Bundl");
      // getDateDropdownList(
      //   "Payout Report",
      //   "2026",
      //   "APR",
      //   "16",
      //   "Device Reimbursement Bundle",
      // );

      setToAndFromDateSubmitButtonRequired(true);
    }

    if (
      filterData.filterType === "CALENDAR" &&
      filterData.filterKey === "toDate"
    ) {
      //setDisplayName(filterData.displayText)
      setToAndFromDateRequired(true);
      setGroupingKey(false);
      var minDay = Number(filterData.filterValues[0]);
      setDatePickerMinDay(minDay);
    }

    if (
      filterData.filterType === "CALENDAR" &&
      filterData.filterKey === "fromDate"
    ) {
      // setDisplayName(filterData.displayText)
      setToAndFromDateRequired(true);
      setGroupingKey(false);
      var minDay = Number(filterData.filterValues[0]);
      setDatePickerMinDay(minDay);
    }

    if (
      filterData.filterType === "CALENDAR" &&
      filterData.filterKey === "date"
    ) {
      //setDisplayName(filterData.displayText)
      setDateFilterRequired(true);
      setGroupingKey(false);
      var minDay = Number(filterData.filterValues[0]);
      setDatePickerMinDay(minDay);
    }

    if (
      filterData.filterType === "DROPDOWN" &&
      filterData.filterKey === "month"
    ) {
      //setDisplayName(filterData.displayText)
      setMonthFilterRequired(true);
      setGroupingKey(false);
      const filterValue = filterData.filterValues;
      const sortedValues = filterValue.sort((a, b) => a - b);
      setMonthDropdwonValue(sortedValues);
      // setDatePickerMinDay(filterData.filterValues[0]);
    }

    if (
      filterData.filterType === "DROPDOWN" &&
      filterData.filterKey === "year"
    ) {
      //setDisplayName(filterData.displayText)
      setYearFilterRequired(true);
      setGroupingKey(false);
      const filterValue = filterData.filterValues;
      const sortedValues = filterValue.sort((a, b) => a - b);
      setYearDropdownValue(sortedValues);
      // setDatePickerMinDay(filterData.filterValues[0]);
    }

    if (
      filterData.filterType === "DROPDOWN" &&
      filterData.filterKey === "getPayoutCycleDates"
    ) {
      setDisplayName(filterData.displayText);
      setDayCycleFilterRequired(true);
      setGroupingKey(false);
      setDateDropdownRequired(true);
      getPayoutCycleDatesDropdownList();
      setToAndFromDateSubmitButtonRequired(true);
    }

    //  if (
    //   filterData.filterType === "DROPDOWN" &&
    //   filterData.filterKey === "getPayoutCycleDates"
    // ) {
    //   //setDisplayName(filterData.displayText)
    //   setDayCycleFilterRequired(true);
    //   const filterValue = filterData.filterValues;
    //   const sortedValues = filterValue.sort((a, b) => a - b);
    //   setYearDropdownValue(sortedValues);
    //   // setDatePickerMinDay(filterData.filterValues[0]);
    // }

    if (
      filterData.filterType === "DROPDOWN" &&
      filterData.filterKey === "getYearList"
    ) {
      // setDisplayName(filterData.displayText)
      setYearFilterRequired(true);
      setGroupingKey(false);
      const filterValue = filterData.filterValues;
      const sortedValues = filterValue.sort((a, b) => a - b);
      setYearDropdownValue(sortedValues);
      // setDatePickerMinDay(filterData.filterValues[0]);
    }

    // if (
    //   filterData.filterType === "DROPDOWN" &&
    //   filterData.filterKey === "groupingKey"
    // ) {
    //   setFilterKey(filterData.filterKey);
    //   setDisplayName(filterData.displayText);
    //   setGroupNameRequired(true);
    //   setGroupNameDropdownValue(filterData.filterValues);
    //   // setDatePickerMinDay(filterData.filterValues[0]);
    // }
  };

  const handleReportSubTypeSelection = (option) => {
    try {
      const today = dayjs();
      setSelectedToDate(dayjs(today).format("DD-MM-YYYY"));
      setSelectedFromDate(dayjs(today).format("DD-MM-YYYY"));

      for (let i = 0; i < subReportType.length; i++) {
        const reportSubTypeArray = subReportType[0];
        if (reportSubTypeArray !== null && reportSubTypeArray.length > 0) {
          // resetFilters();
          for (let i = 0; i < reportSubTypeArray.length; i++) {
            const model = reportSubTypeArray[i];
            if (model.subReportType === option) {
              if (model.filters !== null) {
                for (let j = 0; j < model.filters.length; j++) {
                  const filterData = model.filters[j];
                  setUpFilterType(filterData);
                }
                setFilterValues(model.filters);
                setFilterOptions(model.filters[0].filterType);
              } else {
                setGroupingKey(false);
              }
              setReportFormat(model.reportFormat);
              setReportExtension(model.reportExtension);
              setReportTemplate(model.reportTemplate);
              setIsBranchCodeRequired(model.isBranchCodeRequired);
              setIsCompanyCodeRequired(model.isCompanyCodeRequired);
            }
          }
        }
      }
    } catch (error) {
      DebugLog("error>>>>>>" + error);
    }
  };

  const resetFilters = () => {
    setToAndFromDateSubmitButtonRequired(false);
    //setSubReportType([]);
    setDateDropdownRequired(false);
    setToAndFromDateRequired(false);
    setTextfieldRequired(false);
    setDateFilterRequired(false);
    setMonthFilterRequired(false);
    setYearFilterRequired(false);
    setDayCycleFilterRequired(false);
    setGroupingKey(false);
    setTransactionTypeRequired(false);
    setGroupNameRequired(false);
    setFilterValues([]);
    setFilterOptions([]);
    setDropdownValue([]);
    setDropdownOptions([]);
    setSelectedDropdownBatchNo("");
  };

  const handleReportTypeSelection = (option) => {
    try {
      setReportTypeSelection(option);
      resetFilters();
      let subTypeList = [];
      let filterList = [];
      for (let i = 0; i < reportType.length; i++) {
        const model = reportType[i];

        if (model.reportType === option) {
          setFileType(model.reportFormat);
          // if (model.subTypes === null) {
          setFilterValues(model.filters);

          setReportFormat(model.reportFormat);
          setReportExtension(model.reportExtension);
          setReportTemplate(model.reportTemplate);
          if (model.filters !== null && model.filters.length > 0) {
            for (let i = 0; i < model.filters.length; i++) {
              const filterData = model.filters[i];
              setUpFilterType(filterData);
              filterList.push(filterData);
              setFilterOptions(model.filters[0].filterType);
            }
          }
          setIsBranchCodeRequired(model.isBranchCodeRequired);
          setIsCompanyCodeRequired(model.isCompanyCodeRequired);
          //} else {
          if (model.subTypes !== null) {
            subTypeList.push(model.subTypes);
          }
        }
      }

      if (subTypeList.length > 0) {
        setSubReportType(subTypeList);

        let subTypeListOptions = [];
        for (let i = 0; i < subTypeList.length; i++) {
          const firstIndexArray = subTypeList[0];
          if (firstIndexArray !== null && firstIndexArray.length > 0) {
            for (let i = 0; i < firstIndexArray.length; i++) {
              subTypeListOptions.push(firstIndexArray[i].subReportType);
            }

            setSubReportTypeOptions(subTypeListOptions);
          } else {
            setSubReportTypeOptions([]);
          }
        }
      } else {
        setSubReportTypeOptions([]);
      }

      if (subTypeList.length === 0 && filterList.length === 0) {
        setDisplayFilterLabel(false);
      } else {
        setDisplayFilterLabel(true);
      }
    } catch (error) {
      DebugLog("error>>>>>" + error);
      setDisplayFilterLabel(false);
    }
  };

  useEffect(() => {
    const value = {
      reportType: formData.reportType !== null ? formData.reportType : "",
      subType: formData.subType !== null ? formData.subType : "",
      companyName: formData.companyName !== null ? formData.companyName : "",
      branch: formData.branch !== null ? formData.branch : "",
      addFilter: filterValuesOptions !== null ? filterValuesOptions : "",
      addMoreFilter:
        formData.addMoreFilter !== null ? formData.addMoreFilter : "",
      selectedDateDropdown:
        formData.selectedDateDropdown !== null
          ? formData.selectedDateDropdown
          : "",
      selectedMonth:
        formData.selectedMonth !== null ? formData.selectedMonth : "",
      selectedMonthYear:
        formData.selectedMonthYear !== null ? formData.selectedMonthYear : "",

      transactionType:
        formData.transactionType !== null ? formData.transactionType : "",
      reportGroup: formData.reportGroup !== null ? formData.reportGroup : "",
      dayCycle: formData.dayCycle !== null ? formData.dayCycle : "",

      date: "",
    };
    DebugLog(JSON.stringify({ value }));
    setFormData(value);
  }, [filterValuesOptions]);

  const StyledInputLabel = styled(InputLabel)({
    height: "40px", // Set the desired height for the InputLabel
  });

  function initiateRequestForReportDownload(batchNo, reportName, fileType) {
    try {
      let requestObject;

      const fromDateValue =
        toAndFromDateRequired && selectedFromDate
          ? dayjs(selectedFromDate, "DD-MM-YYYY").isValid()
            ? dayjs(selectedFromDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : ""
          : "";

      const toDateValue =
        toAndFromDateRequired && selectedToDate
          ? dayjs(selectedToDate, "DD-MM-YYYY").isValid()
            ? dayjs(selectedToDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : ""
          : "";

      const monthOnlyValue = monthFilterRequired ? selectedMonth : "";
      const yearOnlyValue = yearFilterRequired ? selectedYear : "";
      const dayCycleValue = dayCycleFilterRequired ? selectedDayCycle : "";

      if (isCompanyCodeRequired && isBranchCodeRequired) {
        requestObject = {
          batchNo: batchNo,
          reportTemplate: reportName,
          reportFormat: fileType,
          companyCode: companyCode,
          branchCode: branchCode !== null ? branchCode : "",

          year: yearOnlyValue,
          month: monthOnlyValue,
          day: dayCycleValue,
          fromDate: fromDateValue,
          toDate: toDateValue,
        };
        // } else if (
        //   (isCompanyCodeRequired && dayCycleFilterRequired) ||
        //   (isCompanyCodeRequired && reportName === "DEALER_PAYOUT_REPORT")
        // ) {

        //   requestObject = {
        //     batchNo: batchNo,
        //     reportTemplate: reportName,
        //     reportFormat: fileType,
        //     companyCode: companyCode,
        //     year: yearOnlyValue,
        //     month: monthOnlyValue,
        //     day: dayCycleValue,
        //     branchCode: branchCode !== null ? branchCode : "",
        //     fromDate: fromDateValue,
        //     toDate: toDateValue,
        //   };
      } else if (isCompanyCodeRequired) {
        requestObject = {
          batchNo: batchNo,
          reportTemplate: reportName,
          reportFormat: fileType,
          companyCode: companyCode,
          year: yearOnlyValue,
          month: monthOnlyValue,
          day: dayCycleValue,
          fromDate: fromDateValue,
          toDate: toDateValue,
        };
      } else {
        requestObject = {
          batchNo: batchNo,
          reportTemplate: reportName,
          reportFormat: fileType,
          year: yearOnlyValue,
          month: monthOnlyValue,
          day: dayCycleValue,
          fromDate: fromDateValue,
          toDate: toDateValue,
        };
      }

      //remove empty values from requestObject
      requestObject = Object.fromEntries(
        Object.entries(requestObject).filter(([_, value]) => value !== ""),
      );

      initializeEncryption(
        requestObject,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.INITIATE_REPORT_PREPRATION,
      ).then((encryptedContentData) => {
        fetchDataFromDownloadInitiate(
          process.env.REACT_APP_REPORT_DOWNLOAD_INITIATE_API_URL,
          ApiType.INITIATE_REPORT_PREPRATION,
          ApiType.POST_METHOD,
          encryptedContentData,
          {},
          (data) => {
            if (data !== null) {
              const alreadyAwaitingDownloadFiles =
                getFromLocalStorageJsonObject(AWAITING_FILE_DOWNLOAD);
              if (
                alreadyAwaitingDownloadFiles === undefined ||
                alreadyAwaitingDownloadFiles === null
              ) {
                const newFileDownloadList = [];
                const newFileForDownload = {
                  reportName: reportName,
                  fileReferenceToken: data.result.fileReferenceToken,
                  fileGenerationStatus: data.result.fileGenerationStatus,
                  fileDownloadPath: data.result.fileDownloadPath,
                };
                newFileDownloadList.push(newFileForDownload);

                saveToLocalStorageJsonObject(
                  AWAITING_FILE_DOWNLOAD,
                  newFileDownloadList,
                );
              } else {
                const newFileDownloadList = [];
                for (let i = 0; i < alreadyAwaitingDownloadFiles.length; i++) {
                  const model = alreadyAwaitingDownloadFiles[i];
                  newFileDownloadList.push(model);
                }

                const newFileForDownload = {
                  reportName: reportName,
                  fileReferenceToken: data.result.fileReferenceToken,
                  fileGenerationStatus: data.result.fileGenerationStatus,
                  fileDownloadPath: data.result.fileDownloadPath,
                };

                newFileDownloadList.push(newFileForDownload);

                saveToLocalStorageJsonObject(
                  AWAITING_FILE_DOWNLOAD,
                  newFileDownloadList,
                );
              }

              showErrorAlert(
                ALERT,
                "Your file will be downloaded soon , please check progress in the notification bar.",
              );

              setInititateFileDownloadTrigger(true);
              //handleClose();
            }
          },
        );
      });
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
      );
    }
  }

  function dealerSearchIconClick() {
    resetAllFields();

    navigate(CONSTANT.SEARCH_AND_SELECT_COMPANY_DETAILS_ROUTE, {
      state: { data: formData, type: 0 },
    });
  }

  function resetAllFields() {
    const value = {
      reportType: "",
      subType: "",
      companyName: "",
      branch: "",
      addFilter: "",
      text: "",
      selectedDateDropdown: "",
      month: "",
      year: "",
      dayCycle: "",
      reportGroup: "",
      transactionType: "",
      addMoreFilter: "",
      date: "",
    };
    setFormData(value);

    setReportTypeSelection("");

    // reset compnay and branch
    setBranchTypeOptions([]);
    setBranchValue([]);

    setCompanyCode("");
    setBranchCode("");

    // reset report type and report sub type
    setReportType([]);
    setReportTypeOptions([]);

    setSubReportTypeOptions([]);
    setSubReportType([]);

    setFilterValues([]);
    setFilterOptions([]);

    setDropdownValue([]);
    setDropdownOptions([]);

    setSelectedDropdownBatchNo("");
    setReportTypeSelection("");

    // reset filters
    setDateDropdownRequired(false);
    setToAndFromDateRequired(false);
    setTextfieldRequired(false);
    setDateFilterRequired(false);

    setMonthFilterRequired(false);
    setYearFilterRequired(false);
    setDayCycleFilterRequired(false);
    setTransactionTypeRequired(false);
    setGroupNameRequired(false);
  }

  function getDateDropdownList(reportName, year, month, day, reportGroup) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        let requestObject;

        requestObject = {
          reportName: reportName,
          year: year,
          month: month,
          day: day,
          category: reportGroup,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_DATE_DROPDOWN_LIST,
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          getDateDropdownListApiData(requestData)
            .then((response) => {
              if (response.data.responseCode === "0") {
                setDropdownOptions(
                  response.data.result.map((item) => item.payoutName),
                );
                setDropdownValue(response.data.result);
              }

              setLoading(false);

              if (
                response.data.result !== null &&
                response.data.result.length === 0
              ) {
                showErrorAlert(ALERT, "No Record Found for Report Names!");
              } else {
                setSelectedDropdownBatchNo(response.data.result[0].batchNo);
              }
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
      );
    }
  }

  function getDateDropdownListData(reportName, fromDate, toDate) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        let requestObject;

        if (
          (fromDate !== null && fromDate !== "") ||
          (fromDate !== "undefined" && fromDate !== "")
        ) {
          requestObject = {
            reportName: reportName,
            fromDate: fromDate,
            toDate: toDate,
          };
        } else {
          requestObject = {
            reportName: reportName,
          };
        }

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_DATE_DROPDOWN_LIST,
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          getDateDropdownListApiData(requestData)
            .then((response) => {
              if (response.data.responseCode === "0") {
                setDropdownOptions(
                  response.data.result.map((item) => item.payoutName),
                );
                setDropdownValue(response.data.result);
              }

              setLoading(false);

              if (
                response.data.result !== null &&
                response.data.result.length === 0
              ) {
                showErrorAlert(ALERT, "No Record Found for Report Names!");
              } else {
                setSelectedDropdownBatchNo(response.data.result[0].batchNo);
              }
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
      );
    }
  }

  function getPayoutCycleDatesDropdownList() {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        //   {
        //     "requestId": "1675411430643",
        //     "loginId": "bizops",
        //     "sessionId": "edsfafwffe"
        // }

        let requestObject = {
          // requestId: reportName,
          // loginId: fromDate,
          // sessionId: toDate,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_PAYOUT_CYCLE_DATES,
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          getPayoutCycleDatesDropdownListData(requestData)
            .then((response) => {
              if (response.data.responseCode === "0") {
                setPayoutCycleDatesDropdownOptions(
                  response.data.result.map((item) => item.payoutName),
                );
                setPayoutCycleDatesValue(response.data.result);
              }

              setLoading(false);

              if (
                response.data.result !== null &&
                response.data.result.length === 0
              ) {
                showErrorAlert(ALERT, "No Record Found for Payout Cycle Date!");
              } //else {
              //   setSelectedDropdownBatchNo(response.data.result[0].batchNo);
              // }
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
      );
    }
  }

  function downloadReportsDetails(formData, type, fileType) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        //   {
        //     "reportType": "", //String - from getReportDetails response -> reportType
        //     "reportSubType": "", //String - from getReportDetails response -> reportTypesubReportType
        //     "companyCode": "", //String - from getCompanyDetails response -> companyCode
        //     "branchCode": "", //String - from getBranchDetails response -> branchCode
        //     "payoutDate": "", //LocalDate - from getPayoutNameList response -> payoutDate (yyyy-mm-dd)
        //     "fromDate": "", //LocalDate - user selection -> yyyy-mm-dd
        //     "toDate": "", //LocalDate - user selection -> yyyy-mm-dd
        //     "month": "", //Integer - user selection -> mm
        //     "year": "", //Integer - user selection -> yyyy
        //     "transactionType": "", //String - from getReportDetails response -> filter values supported only
        //     "accountType": "", //String - from getReportDetails response -> filter values supported only
        //     "date": "" //LocalDate - user selection -> yyyy-mm-dd
        // }

        const reportSubTypeValue =
          subReportTypeOptions.length > 0 ? formData.subType : "";

        const selectedDropdownValue = dateDropdownRequired
          ? formData.selectedDateDropdown
          : "";

        const fromDateValue =
          toAndFromDateRequired && selectedFromDate
            ? dayjs(selectedFromDate, "DD-MM-YYYY").isValid()
              ? dayjs(selectedFromDate, "DD-MM-YYYY").format("YYYY-MM-DD")
              : ""
            : "";

        const toDateValue =
          toAndFromDateRequired && selectedToDate
            ? dayjs(selectedToDate, "DD-MM-YYYY").isValid()
              ? dayjs(selectedToDate, "DD-MM-YYYY").format("YYYY-MM-DD")
              : ""
            : "";
        const monthOnlyValue = monthFilterRequired ? selectedMonth : "";
        const yearOnlyValue = yearFilterRequired ? selectedYear : "";
        //const dayCycleValue = dayCycleFilterRequired ? selectedDayCycle : "";
        const date = dateFilterRequired ? selectedDate : "";

        const reportType =
          formData.reportType !== null ? formData.reportType : "";
        let transactionType = "";
        let accountType = "";

        if (filterKey === "transactionType") {
          transactionType = transactionTypeRequired
            ? selectedTrnsactionType
            : "";
        } else if (filterKey === "accountType") {
          accountType = transactionTypeRequired ? selectedTrnsactionType : "";
        }

        let requestObject;

        if (isCompanyCodeRequired && isBranchCodeRequired) {
          requestObject = {
            reportType: reportType,
            reportSubType: reportSubTypeValue,
            companyCode: companyCode !== null ? companyCode : "",
            branchCode: branchCode !== null ? branchCode : "",
            fromDate: fromDateValue,
            toDate: toDateValue,
            payoutDate: selectedDropdownValue,
            month: monthOnlyValue,
            year: yearOnlyValue,
            transactionType: transactionType,
            accountType: accountType,
            date: date,
          };
        } else if (isCompanyCodeRequired && !isBranchCodeRequired) {
          requestObject = {
            reportType: reportType,
            reportSubType: reportSubTypeValue,
            companyCode: companyCode !== null ? companyCode : "",
            fromDate: fromDateValue,
            toDate: toDateValue,
            payoutDate: selectedDropdownValue,
            month: monthOnlyValue,
            year: yearOnlyValue,
            transactionType: transactionType,
            accountType: accountType,
            date: date,
          };
        } else {
          requestObject = {
            reportType: reportType,
            reportSubType: reportSubTypeValue,
            fromDate: fromDateValue,
            toDate: toDateValue,
            payoutDate: selectedDropdownValue,
            month: monthOnlyValue,
            year: yearOnlyValue,
            transactionType: transactionType,
            accountType: accountType,
            date: date,
          };
        }
        requestObject = Object.fromEntries(
          Object.entries(requestObject).filter(([_, value]) => value !== ""),
        );
        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.REPORT_MODULE_FILE_DOWNLOAD,
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          downloadReportModuleFile(requestData, type)
            .then((response) => {
              // Determine the content type from the headers
              const contentType = response.headers["content-type"];
              const mimeType = contentType.split(";")[0];

              // Handle different content types
              if (mimeType.includes("application/json")) {
                const arrayBuffer = response.data;

                // Function to convert ArrayBuffer to JSON
                const arrayBufferToJson = (buffer) => {
                  const decoder = new TextDecoder("utf-8");
                  const jsonString = decoder.decode(buffer);
                  return JSON.parse(jsonString);
                };

                // Convert the ArrayBuffer to JSON and set it in state
                const jsonObject = arrayBufferToJson(arrayBuffer);

                // setJsonData(jsonObject);
                // printLog("JSON data:", JSON.stringify(jsonObject));

                if (jsonObject !== null && jsonObject.responseCode === "-1") {
                  if (
                    jsonObject.displayErrorMessage !== null &&
                    jsonObject.displayErrorMessage !== ""
                  ) {
                    showErrorAlert(ERROR, jsonObject.displayErrorMessage);
                  } else {
                    showErrorAlert(ERROR, jsonObject.errorDescription);
                  }
                }
              } else {
                // Handle binary data
                //const blob = new Blob([response.data], { type: contentType });
                let blob;
                const currentDate = new Date();
                const day = String(currentDate.getDate()).padStart(2, "0");
                const month = String(currentDate.getMonth() + 1).padStart(
                  2,
                  "0",
                );
                const year = String(currentDate.getFullYear());

                // let filename be "EarmarkReport_YYYY-MM-DD"
                let filename = `${formData.reportType}_${year}-${month}-${day}`;
                switch (fileType) {
                  case "CSV":
                    blob = new Blob([response.data], { type: "text/csv" });
                    filename = filename + ".csv";
                    break;
                  case "XLS":
                    blob = new Blob([response.data], {
                      type: "application/vnd.ms-excel",
                    });
                    filename = filename + ".xls";
                    break;
                  case "PDF":
                    blob = new Blob([response.data], {
                      type: "application/pdf",
                    });
                    filename = filename + ".pdf";
                    break;

                  default:
                    throw new Error("Invalid file type");
                }

                // Use FileSaver to save the file
                saveAs(blob, filename);
              }
              //  else {
              //   showErrorAlert(ERROR,`Unsupported content type: ${contentType}`);
              // }

              setLoading(false);
            })
            .catch((error) => {
              setLoading(false);
              if (
                error !== null &&
                error !== undefined &&
                error.data !== null &&
                error.data !== undefined &&
                error.data.errorCode != null &&
                error.data.errorCode !== undefined &&
                error.data.errorCode === ApiErrorCode.SESSION_EXPIRED
              ) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message),
      );
    }
  }

  return (
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />

        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
          onConfirm={handleErrorDialogConfirm}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}

        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Header */}
          <Grid container direction={"row"} alignItems={"center"}>
            <Grid item mr={2}></Grid>
            <Grid item>
              <Typography
                color={colors.grey[100]}
                fontWeight={"600"}
                variant="h3"
              >
                Reports
              </Typography>
            </Grid>
          </Grid>
          {/* Header */}

          {/* Form Filter */}

          <Grid
            container
            mt={2}
            p={6}
            direction={"column"}
            alignItems={"left"}
            sx={{
              background: colors.grey[900],
              borderRadius: "12px",
            }}
          >
            <Grid item alignSelf={"center"}>
              <Typography
                color={colors.grey[100]}
                fontWeight={"700"}
                variant="h6"
              >
                Select Your Preferences
              </Typography>
            </Grid>
            <Grid container mt={1.5} xs={6} spacing={3}>
              <form>
                <Grid container direction={"column"}>
                  <Grid
                    container
                    xs={20}
                    alignItems={"center"}
                    spacing={3}
                    mt={0.5}
                  >
                    {isCompanyCodeRequired && !isExternalUser ? (
                      <Grid
                        container
                        xs={20}
                        alignItems={"center"}
                        spacing={3}
                        mt={0.5}
                      >
                        <Grid item xs={2}>
                          <Typography
                            color={colors.grey[100]}
                            fontWeight={"500"}
                            variant="h7"
                            sx={{ textAlign: "right", fontWeight: "bold" }}
                          >
                            Company
                          </Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Tooltip
                            title="Click on the right side icon"
                            placement="right"
                            arrow
                            enterDelay={500}
                            leaveDelay={200}
                          >
                            <TextField
                              margin="dense"
                              label="Search by Name / Code "
                              type="text"
                              name="companyName"
                              fullWidth
                              inputProps={{ style: { height: "20px" } }}
                              value={formData.companyName}
                              onChange={handleInputChange}
                              error={Boolean(errors.companyName)}
                              helperText={errors.companyName}
                              InputProps={{
                                readOnly: true,
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton>
                                      <Search onClick={dealerSearchIconClick} />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}

                    {isBranchCodeRequired ? (
                      <Grid container xs={20} alignItems={"center"} spacing={3}>
                        <Grid item xs={2}>
                          <Typography
                            color={colors.grey[100]}
                            fontWeight={"500"}
                            variant="h7"
                            sx={{ textAlign: "right", fontWeight: "bold" }}
                          >
                            Branch
                          </Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            error={!!errors.description}
                          >
                            <StyledInputLabel id="demo-simple-select-outlined-label">
                              Select Branch
                            </StyledInputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              name="branch"
                              //value={selectedValue}
                              // onChange={handleTypeDropdownChange}
                              label="Select Branch"
                              inputProps={{ style: { height: "20px" } }}
                              fullWidth
                              value={formData.branch}
                              onChange={handleInputChange}
                              error={Boolean(errors.branch)}
                              helperText={errors.branch}
                              MenuProps={{
                                PaperProps: { style: dropdownStyle },
                              }} // Apply styles to the dropdown menu
                            >
                              {branchTypeOpitons.map((option, index) => (
                                <MenuItem
                                  key={index}
                                  value={option}
                                  onClick={() => handleBranchSelection(option)}
                                >
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText>{errors.branch}</FormHelperText>
                          </FormControl>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}

                    <Grid item xs={2}>
                      <Typography
                        color={colors.grey[100]}
                        fontWeight={"500"}
                        variant="h7"
                        sx={{ textAlign: "right", fontWeight: "bold" }}
                      >
                        Report Type
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <FormControl
                        variant="outlined"
                        fullWidth
                        error={!!errors.reportType}
                      >
                        <StyledInputLabel id="demo-simple-select-outlined-label">
                          Select Report Type
                        </StyledInputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          name="reportType"
                          //value={selectedValue}
                          // onChange={handleTypeDropdownChange}
                          label="Select Report Type"
                          inputProps={{ style: { height: "20px" } }}
                          fullWidth
                          value={formData.reportType}
                          onChange={handleInputChange}
                          error={Boolean(errors.reportType)}
                          helperText={errors.reportType}
                          MenuProps={{ PaperProps: { style: dropdownStyle } }} // Apply styles to the dropdown menu
                        >
                          {reportTypeOptions.map((option, index) => (
                            <MenuItem
                              key={index}
                              value={option}
                              onClick={() => handleReportTypeSelection(option)}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>{errors.reportType}</FormHelperText>
                      </FormControl>
                    </Grid>
                  </Grid>

                  {subReportTypeOptions.length > 0 ? (
                    <Grid
                      container
                      xs={20}
                      alignItems={"center"}
                      spacing={3}
                      mt={2}
                    >
                      <Grid item xs={2}>
                        <Typography
                          color={colors.grey[100]}
                          fontWeight={"500"}
                          variant="h7"
                          sx={{ textAlign: "right", fontWeight: "bold" }}
                        >
                          Sub Type
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <FormControl
                          variant="outlined"
                          fullWidth
                          error={!!errors.subType}
                        >
                          <StyledInputLabel id="demo-simple-select-outlined-label">
                            Select SubType
                          </StyledInputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            name="subType"
                            //value={selectedValue}
                            // onChange={handleTypeDropdownChange}
                            label="Select SubType"
                            inputProps={{ style: { height: "20px" } }}
                            fullWidth
                            value={formData.subType}
                            onChange={handleInputChange}
                            error={Boolean(errors.subType)}
                            helperText={errors.subType}
                            MenuProps={{ PaperProps: { style: dropdownStyle } }} // Apply styles to the dropdown menu
                          >
                            {subReportTypeOptions.map((option, index) => (
                              <MenuItem
                                key={index}
                                value={option}
                                onClick={() =>
                                  handleReportSubTypeSelection(option)
                                }
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>{errors.subType}</FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                  ) : (
                    ""
                  )}

                  <Grid
                    container
                    xs={20}
                    alignItems={"center"}
                    spacing={2}
                    mt={4}
                  >
                    {displayFilterLabel === true ? (
                      <Grid item xs={2}>
                        <Typography
                          color={colors.grey[100]}
                          fontWeight={"500"}
                          variant="h7"
                          sx={{ textAlign: "right", fontWeight: "bold" }}
                        >
                          Filter
                        </Typography>
                      </Grid>
                    ) : (
                      ""
                    )}
                    <Grid container xs={10}>
                      {/* <Grid item xs={7}>
                        <FormControl
                          variant="outlined"
                          fullWidth
                          error={!!errors.addFilter}
                        >
                          <StyledInputLabel id="demo-simple-select-outlined-label">
                             Filter Type
                          </StyledInputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            name="addFilter"
                            //value={selectedValue}
                            // onChange={handleTypeDropdownChange}
                            label="Filter"
                            inputProps={{ style: { height: "20px" } }}
                            fullWidth
                            disabled
                            value={formData.addFilter}
                            onChange={handleInputChange}
                            error={Boolean(errors.addFilter)}
                            helperText={errors.addFilter}
                            MenuProps={{
                              PaperProps: { style: dropdownStyle },
                            }} // Apply styles to the dropdown menu
                          >
                            {CONSTANT.reportFilterOptions.map(
                              (option, index) => (
                                <MenuItem key={index} value={option.value}>
                                  {" "}
                                  {option.label}{" "}
                                </MenuItem>
                              )
                            )}
                          </Select>
                          <FormHelperText>{errors.addFilter}</FormHelperText>
                        </FormControl>
                      </Grid> */}

                      {/* TEXTFILED  START */}

                      {textfieldRequired === true ? (
                        <Grid item xs={7}>
                          <TextField
                            margin="dense"
                            label="Text"
                            type="text"
                            name="text"
                            inputProps={{ maxLength: 10 }}
                            maxLength={10}
                            fullWidth
                            value={formData.text}
                            onChange={handleInputChange}
                            error={Boolean(errors.text)}
                            helperText={errors.text}
                          />
                        </Grid>
                      ) : (
                        ""
                      )}
                      {/* TEXTFILED  END */}

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                      {/* From and To date  START */}
                      {toAndFromDateRequired === true ? (
                        <Grid container xs={12} spacing={2}>
                          <Grid item xs={4}>
                            <DesktopDatePicker
                              label="From"
                              format={DATE_FORMAT}
                              value={getDatePickerValue(selectedFromDate)}
                              minDate={getDatePickerMin(0)}
                              maxDate={getDatePickerMax(0)}
                              onChange={(newValue) =>
                                handleDatePickerChange(newValue, 0, "from")
                              }
                              slotProps={{
                                textField: {
                                  margin: "dense",
                                  name: "from",
                                  fullWidth: true,
                                  error: Boolean(errors.from),
                                  helperText: errors.from,
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      height: "20px",
                                    },
                                  },
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={4} mt={1}>
                            <DesktopDatePicker
                              label="To"
                              format={DATE_FORMAT}
                              value={getDatePickerValue(selectedToDate)}
                              minDate={getDatePickerMin(1)}
                              maxDate={getDatePickerMax(1)}
                              onChange={(newValue) =>
                                handleDatePickerChange(newValue, 1, "to")
                              }
                              slotProps={{
                                textField: {
                                  name: "to",
                                  fullWidth: true,
                                  error: Boolean(errors.to),
                                  helperText: errors.to,
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      height: "20px",
                                    },
                                  },
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={2} mt={1} justifyContent={"center"}>
                            {toAndFromDateSubmitButtonRequired === true ? (
                              <CustomButton
                                btnBG={colors.primary[100]}
                                btnColor={colors.grey[900]}
                                btnBorder={"1px solid" + colors.primary[100]}
                                btnTxt={"Get Payout Names"}
                                onClick={getPayoutNamesList}
                              ></CustomButton>
                            ) : (
                              ""
                            )}
                          </Grid>
                        </Grid>
                      ) : (
                        ""
                      )}

                      {dateFilterRequired === true ? (
                        <Grid item xs={7}>
                          <DesktopDatePicker
                            label="Date"
                            format={DATE_FORMAT}
                            value={getDatePickerValue(selectedDate)}
                            minDate={getDatePickerMin(2)}
                            maxDate={getDatePickerMax(2)}
                            onChange={(newValue) =>
                              handleDatePickerChange(newValue, 2, "date")
                            }
                            slotProps={{
                              textField: {
                                margin: "dense",
                                name: "date",
                                fullWidth: true,
                                error: Boolean(errors.date),
                                helperText: errors.date,
                                sx: {
                                  "& .MuiInputBase-input": {
                                    height: "20px",
                                  },
                                },
                              },
                            }}
                          />
                        </Grid>
                      ) : (
                        ""
                      )}
                      </LocalizationProvider>
                      {/* Item 1 - Transaction Type - Full width on top */}
                      {transactionTypeRequired === true && (
                        <Grid item xs={12}>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            error={!!errors.transactionType}
                          >
                            <StyledInputLabel id="demo-simple-select-outlined-label">
                              {groupingKeyDisplayName
                                ? groupingKeyDisplayName
                                : "Transaction Type"}
                            </StyledInputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              name="transactionType"
                              label={
                                groupingKeyDisplayName
                                  ? groupingKeyDisplayName
                                  : "Transaction Type"
                              }
                              inputProps={{ style: { height: "20px" } }}
                              fullWidth
                              value={formData.transactionType}
                              onChange={handleInputChange}
                              error={Boolean(errors.transactionType)}
                              helperText={errors.transactionType}
                              MenuProps={{
                                PaperProps: { style: dropdownStyle },
                              }}
                            >
                              {transactionTypeDropdownValue.map(
                                (option, index) => (
                                  <MenuItem
                                    key={index}
                                    value={option}
                                    onClick={() =>
                                      handleTransactionDropdownSelection(option)
                                    }
                                  >
                                    {option}
                                  </MenuItem>
                                ),
                              )}
                            </Select>
                            <FormHelperText>
                              {errors.transactionType}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      )}

                      {/* Items 2, 3, 4 - Month, Year, Day Cycle - Horizontal row */}
                      <Grid item xs={12}>
                        <Stack direction="row" spacing={2}>
                          {/* Item 2 - Month */}
                          {monthFilterRequired === true && (
                            <FormControl
                              variant="outlined"
                              fullWidth
                              error={!!errors.month}
                            >
                              <StyledInputLabel id="month-select-label">
                                Select Month
                              </StyledInputLabel>
                              <Select
                                labelId="month-select-label"
                                id="month-select"
                                name="month"
                                label="Select Month"
                                inputProps={{ style: { height: "20px" } }}
                                fullWidth
                                value={formData.month}
                                onChange={handleInputChange}
                                error={Boolean(errors.month)}
                                helperText={errors.month}
                                MenuProps={{
                                  PaperProps: { style: dropdownStyle },
                                }}
                              >
                                {monthDropdownValue.map((option, index) => (
                                  <MenuItem
                                    key={index}
                                    value={option}
                                    onClick={() =>
                                      handleMonthDropdownSelection(option)
                                    }
                                  >
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                              <FormHelperText>{errors.month}</FormHelperText>
                            </FormControl>
                          )}

                          {/* Item 3 - Year */}
                          {yearFilterRequired === true && (
                            <FormControl
                              variant="outlined"
                              fullWidth
                              error={!!errors.year}
                            >
                              <StyledInputLabel id="year-select-label">
                                Select Year
                              </StyledInputLabel>
                              <Select
                                labelId="year-select-label"
                                id="year-select"
                                name="year"
                                label="Select Year"
                                inputProps={{ style: { height: "20px" } }}
                                fullWidth
                                value={formData.year}
                                onChange={handleInputChange}
                                error={Boolean(errors.year)}
                                helperText={errors.year}
                                MenuProps={{
                                  PaperProps: { style: dropdownStyle },
                                }}
                              >
                                {yearDropdownValue.map((option, index) => (
                                  <MenuItem
                                    key={index}
                                    value={option}
                                    onClick={() =>
                                      handleYearDropdownSelection(option)
                                    }
                                  >
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                              <FormHelperText>{errors.year}</FormHelperText>
                            </FormControl>
                          )}

                          {/* Item 4 - Day Cycle */}
                          {dayCycleFilterRequired === true && (
                            <FormControl
                              variant="outlined"
                              fullWidth
                              error={!!errors.dayCycle}
                            >
                              <StyledInputLabel id="daycycle-select-label">
                                Select Day Cycle
                              </StyledInputLabel>
                              <Select
                                labelId="daycycle-select-label"
                                id="daycycle-select"
                                name="dayCycle"
                                label="Select Day Cycle"
                                inputProps={{ style: { height: "20px" } }}
                                fullWidth
                                value={formData.dayCycle}
                                onChange={handleInputChange}
                                error={Boolean(errors.selectedDayCycleDropdown)}
                                helperText={errors.selectedDayCycleDropdown}
                                MenuProps={{
                                  PaperProps: { style: dropdownStyle },
                                }}
                              >
                                {payoutCycleValue.map((option, index) => (
                                  <MenuItem
                                    key={index}
                                    value={option}
                                    onClick={() =>
                                      handleDayCycleDropdownSelection(option)
                                    }
                                  >
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                              <FormHelperText>
                                {errors.selectedDayCycleDropdown}
                              </FormHelperText>
                            </FormControl>
                          )}
                        </Stack>
                      </Grid>
                      {/* From and To date  END */}

                      {isGroupingKey === true ||
                      dateDropdownRequired === true ? (
                        <Grid item xs={7}>
                          <Box
                            display="flex"
                            alignItems="center"
                            sx={{ mt: 2, mb: 2 }}
                          >
                            <Box sx={{ height: 20 }} />
                            <CustomButton
                              btnBG={colors.primary[100]}
                              btnColor={colors.grey[900]}
                              btnBorder={"1px solid" + colors.primary[100]}
                              btnTxt={"Get Payout Report Names"}
                              onClick={getReportNamesList}
                            ></CustomButton>
                          </Box>
                        </Grid>
                      ) : (
                        ""
                      )}

                      {dateDropdownRequired === true ? (
                        <Grid item xs={7}>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            error={!!errors.selectedDateDropdown}
                          >
                            <StyledInputLabel id="demo-simple-select-outlined-label">
                              Select Report Name
                            </StyledInputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              name="selectedDateDropdown"
                              //value={selectedValue}
                              // onChange={handleTypeDropdownChange}
                              label="Select Report Name"
                              inputProps={{ style: { height: "20px" } }}
                              fullWidth
                              value={formData.selectedDateDropdown}
                              onChange={handleInputChange}
                              error={Boolean(errors.selectedDateDropdown)}
                              helperText={errors.selectedDateDropdown}
                              MenuProps={{
                                PaperProps: { style: dropdownStyle },
                              }} // Apply styles to the dropdown menu
                            >
                              {dropdownOpitons.map((option, index) => (
                                <MenuItem
                                  key={index}
                                  value={option}
                                  onClick={() =>
                                    handleDateDropdownSelection(option,index)
                                  }
                                >
                                  {option}
                                </MenuItem>
                              ))}

                              {/* {CONSTANT.reportDateOptions.map((option, index) => (
                              <MenuItem key={index} value={option.value}>
                                {" "}
                                {option.label}{" "}
                              </MenuItem>
                            ))} */}
                            </Select>
                            <FormHelperText>
                              {errors.selectedDateDropdown}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>

                  {/* <Grid container xs={20} alignItems={"center"} spacing={3}>
                    <Grid item xs={2}>
                      <Typography
                        color={colors.grey[100]}
                        fontWeight={"500"}
                        variant="h7"
                        sx={{ textAlign: "right" }}
                      >
                        Date
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        inputProps={{ style: { height: "20px" } }}
                        margin="dense"
                        label="Date"
                        type="text"
                        name="date"
                        fullWidth
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton>
                                <DateRange onClick={chooseDateOptionClicked} />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        value={selectedDate}
                        onChange={handleInputChange}
                        error={Boolean(errors.date)}
                        helperText={errors.date}
                      />
                    </Grid>
                  </Grid> */}

                  {/* <Grid
                    container
                    xs={20}
                    alignItems={"center"}
                    spacing={3}
                    mt={0.0}
                    pb={0.5}
                  >
                    <Grid item xs={2}>
                      <Typography
                        color={colors.grey[900]}
                        fontWeight={"600"}
                        variant="h7"
                        sx={{ textAlign: "right" }}
                      >
                        From - to Date
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <TextField
                            inputProps={{ style: { height: "20px" } }}
                            margin="dense"
                            label="From"
                            name="from"
                            type="text"
                            fullWidth
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton>
                                    <DateRange
                                      onClick={chooseFromDateOptionClicked}
                                    />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                            value={selectedDate}
                            onChange={handleInputChange}
                            error={Boolean(errors.from)}
                            helperText={errors.from}
                          />
                        </Grid>
                        <Grid item xs={6} mt={1}>
                          <TextField
                            inputProps={{ style: { height: "20px" } }}
                            fullWidth
                            label="To"
                            name="to"
                            type="text"
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton>
                                    <DateRange
                                      onClick={chooseToDateOptionClicked}
                                    />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                            value={selectedToDate}
                            onChange={handleInputChange}
                            error={Boolean(errors.to)}
                            helperText={errors.to}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid> */}

                  {/* <Grid container xs={20} alignItems={"center"} spacing={3}>
                    <Grid item xs={2}>
                      <Typography
                        color={colors.grey[100]}
                        fontWeight={"500"}
                        variant="h7"
                        sx={{ textAlign: "right" }}
                      >
                        Refrence
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <TextField
                        margin="dense"
                        label="e.g. (YA_XXXXXX)"
                        type="text"
                        name="refrenceNo"
                        inputProps={{
                          style: { height: "20px" },
                          maxLength: 50,
                        }}
                        fullWidth
                        value={formData.refrenceNo}
                        onChange={handleInputChange}
                        error={Boolean(errors.refrenceNo)}
                        helperText={errors.refrenceNo}
                      />
                    </Grid>
                  </Grid> */}
                  {/* 
                  { editAllowed === null || editAllowed === true  ? (
  ) : (
    ""
  )} */}
                  <Stack
                    direction="row"
                    pt={5}
                    spacing={2}
                    mr={15}
                    pb={20}
                    justifyContent={"center"}
                  >
                    {/* {flowProp === "0" ? (
                      <CustomButton
                        btnBG={colors.primary[900]}
                        btnColor={colors.grey[100]}
                        btnTxt={"CANCEL ADJUSTMENT"}
                        btnBorder={"1px solid" + colors.primary[800]}
                        onClick={cancelAdjustment}
                      ></CustomButton>
                    ) : (
                      ""
                    )} */}
                    <CustomButton
                      btnBG={colors.primary[100]}
                      btnColor={colors.grey[900]}
                      btnTxt={"     DOWNLOAD REPORT    "}
                      btnBorder={"1px solid" + colors.primary[100]}
                      onClick={handleSubmit}
                    ></CustomButton>
                  </Stack>
                </Grid>

                {/* Add more fields as needed */}
              </form>
            </Grid>
          </Grid>

          {/* Form Filter */}
        </Grid>
      </SnackbarProvider>
    </Box>
  );
};

export default FilterReports;
